import { render } from "./Hero.vue?vue&type=template&id=f59bdc86&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=f59bdc86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59bdc86"]])

export default __exports__